import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { DistanceRightBlock } from './layout'
import Distance from 'commons/js/ui/Distance'

const DistanceBlock = ({ distance }) => (
    <DistanceRightBlock>
        <FormattedMessage
          {...messages.distance}
          values={{
            distance: <Distance fontWeight='book' color='gray' distance={distance} />,
        }}
    />
    </DistanceRightBlock>
)

DistanceBlock.propTypes = {
    distance: PropTypes.number,
}

export default DistanceBlock
